export function newTaskDraft() {
  return { titulo: '', descricao: '', project_id: '', stage_id: null, tipo: 'tarefa', prioridade: 'media',
    status: 'aberto', data_inicio: null, prazo: null, contact_id: null, contact_nome: null, assignee_ids: [] }
}

export function taskCreationPayload(task) {
  if (!task.titulo?.trim()) throw new Error('Informe o nome da tarefa.')
  if (!task.project_id) throw new Error('Selecione um projeto para criar a tarefa.')
  return { titulo: task.titulo.trim(), descricao: task.descricao || null, tipo: task.tipo,
    prioridade: task.prioridade, stage_id: task.stage_id || null,
    data_inicio: task.data_inicio || null, prazo: task.prazo || null,
    assignee_ids: [...new Set(task.assignee_ids || [])],
    ...(task.contact_id ? { contact_id: task.contact_id } : {}) }
}
